import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, ModalService, NotificationService } from 'yt-ng-framework';
import { SistRadnihMesta } from './sist-radnih-mesta';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-sist-radnih-mesta-update',
  templateUrl: './sist-radnih-mesta-update.component.html'
})
export class SistRadnihMestaUpdateComponent
extends BaseUpdateComponent<SistRadnihMesta>
implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected modalService: ModalService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService,modalService);
   }

  ngOnInit() {

    super.ngOnInit();

  }

  ngAfterViewInit()
  {
    setTimeout(()=>{
      this.baseFormGroup.get("Naziv").disable();
    }, 0)
  }

}
